import React, { useState, useEffect } from "react";
import { useTable, useSortBy } from "react-table";
import { Link, Redirect } from "react-router-dom";
import { Form, Field } from "react-final-form";
import DatePicker from "react-datepicker";


import { API_URL, CONTINENTS, GET_VAT_COUNTRIES, POST_ME, GET_ME, GET_ADMIN_RETURNS_FOR_PERIOD, POST_VAT_NUMBER_ID} from "../../../constants";
import { GET_TOKEN, OBJECT_EMPTY, ARRAY_EMPTY, GET_USER_LEVEL } from "../../../helpers";

import { SelectInput } from "../../Global/SelectInput/SelectInput";
import { ReactTable } from "../../Global/ReactTable/ReactTable";
import { LoadingSpinner } from "../partials/LoadingSpinner";
import { Modal } from "../../Global/Modal/Modal";
import { Input } from "../../Global/Input/Input";
import { Pager } from "../Pager/Pager";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./VatRegistrations.css";

export const VatRegistrations = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageCount, setMaxPageCount] = useState(1);
  const [dataLoaded, setDataLoaded] = useState(true);
  const [modalLoading, setModalLoading] = useState(false);

  const [disableSubmit, setDisableSubmit] = useState(false)

  const [currentStep, setCurrentStep] = useState(1);
  const [currentContinent, setCurrentCountry] = useState("EUR");
  const [showModal, setShowModal] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState({});
  const [countries, setCountries] = useState({});
  // const [moss, setMoss] = useState(false);

  const [addNewVatReg, setAddNewVatReg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [fullVatData, setFullVatData] = useState([]);
  const [tableVatData, setTableVatData] = useState([]);

  // ADMIN 
  const [currentReportingPeriod, setCurrentReportingPeriod] = useState({})
  const [reportingPeriodOptionsModal, setReportingPeriodOptionsModal] = useState(false);
  const [reportingPeriodOptions, setReportingPeriodOptions] = useState([]);
  const [currentPeriod, setCurrentPeriod] = useState({});
  const [vatNumberUpdate, setVatNumberUpdate] = useState({})

  const reportingPeriodoptions = [
    {
      label: 'Monthly',
      value: 'monthly'
    },
    {
      label: 'Quarterly',
      value: 'quarterly'
    },
    {
      label: 'Semi-annual',
      value: 'half_yearly'
    },
    {
      label: 'Annual',
      value: 'annual'
    },
  ]

  // pager settings
  const currentPageSetter = (e) => {
    setCurrentPage(parseInt(e.target.getAttribute("value")));
  };

  const periodTranslate = (period_value) => {
    switch (period_value) {
      case 'monthly': {
        return 'Monthly'
      }

      case 'quarterly': {
        return 'Quarterly'
      }

      case 'half_yearly': {
        return 'Semi-annual'
      }

      case 'annual': {
        return 'Annual'
      }
      
      default : {
        return ""
      }
    }
  }

  const setCurrentContinentSibling = (e, continent) => {
    const sibling =
      e.target.nodeName === "SPAN"
        ? e.target.parentNode.previousSibling
        : e.target.previousSibling;
    const existingSibling = document.querySelector("[sibling='true']");

    return [
      existingSibling && existingSibling.setAttribute("sibling", "false"),
      sibling && sibling.setAttribute("sibling", "true"),
      setCurrentCountry(continent),
    ];
  };

  const currentPageSetterIncrease = () => {
    currentPage < maxPageCount && setCurrentPage(currentPage + 1);
  };

  const currentPageSetterDecrease = () => {
    currentPage > 1 && setCurrentPage(currentPage - 1);
  };

  // settings button
  const tableTooltip = (event) => {
    let currentTooltip = event.target.parentNode.childNodes[1];
    currentTooltip.classList.add("active");
  };

  const getCountries = () => {
    let mossExists = currentContinent === "EUR";

    return countries[currentContinent].map((item, index) => {
      return (
        <div className='country-select' key={index}>
          {index === 0 && mossExists && mossCheckbox()}

          <label className={item.disabled || tableVatData.filter((tableItem) => tableItem.country === item.name).length > 0 ? "disabled-input" : ""}>
            <Field
              name={currentContinent}
              component="input"
              type="checkbox"
              imgurl={item.img}
              value={item.name}
              checked={selectedCountries[item.name] !== undefined || tableVatData.filter((tableItem) => tableItem.country === item.name).length > 0}
              disabled={item.disabled || tableVatData.filter((tableItem) => tableItem.country === item.name).length > 0}
              onClick={(e) => checkboxOnClick(e)}
            />

            {item.name}
          </label>
        </div>
      );
    });
  };

  const getContinents = (values) => {
    return Object.entries(countries).map(([continent]) => {
      return (
        <div
          className={
            "country-row" +
            ((currentContinent === continent && " tab-active") || "")
          }
          key={continent}
          sibling="false"
          onClick={(e) => {
            setCurrentContinentSibling(e, continent);
          }}
        >
          <div className={"logo " + continent}></div>
          {CONTINENTS[continent]}

          {values[continent] ? (
            values[continent].length > 0 ? (
              <span className="count">{values[continent].length}</span>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </div>
      );
    });
  };

  const checkboxOnClick = (obj) => {
    if (obj.target.checked) {
      return setSelectedCountries({
        ...selectedCountries,
        [obj.target.value]: {
          continent: obj.target.name,
          country: obj.target.value.toString(),
          img: obj.target.getAttribute("imgurl"),
          dates: {
            startdate: null,
            enddate: null,
          },
        },
      });
    } else {
      let previousCountriesObject = selectedCountries;
      delete previousCountriesObject[obj.target.value];

      setSelectedCountries(previousCountriesObject);
    }
  };

  const setDate = (newDate, countryItem, dateType) => {
    const currentDate = newDate.setTime(newDate.getTime() + (3*60*60*1000));
    const dateToSet = new Date(currentDate)
    // console.log(dateToSet)

    setSelectedCountries({
      ...selectedCountries,
      [countryItem]: {
        ...selectedCountries[countryItem],
        dates: {
          ...selectedCountries[countryItem]["dates"],
          [dateType]: dateToSet,
        },
      },
    });
  };

  const listSelectedCountriesModal = () => {
    return Object.entries(selectedCountries).map(
      ([currentCountry, itemValues], index) => {
        const countryItem = currentCountry;
        const countryName = currentCountry == "moss" ? "Oss" : currentCountry;

        return (
          <tr className="date-item" key={countryItem + index}>
            <td className="date-item__name flex-align-center">
              {itemValues.img === "moss" ? (
                <div className="icon moss"></div>
              ) : (
                <img
                  src={itemValues.img}
                  className="flag-icon-img"
                  alt={countryItem}
                />
              )}
            {countryName === "moss"? "oss" : countryName }
            </td>
            <td>
              {/* https://github.com/Hacker0x01/react-datepicker/issues/1757 */}
              <DatePicker
                dateFormat="yyyy-MM-dd"
                autoComplete="off"
                name={"startdate_" + countryItem}
                country={countryItem}
                selected={
                  selectedCountries[countryItem]
                    ? selectedCountries[countryItem]["dates"]["startdate"]
                    : ""
                }
                onChange={(newDate) => {
                  setDate(newDate, countryItem, "startdate");
                }}
                placeholderText="YYYY-MM-DD"
                className="default-input"
                selectsEnd
              />
            </td>
            <td>
              <DatePicker
                dateFormat="yyyy-MM-dd"
                autoComplete="off"
                name={"enddate_" + countryItem}
                selected={
                  selectedCountries[countryItem]
                    ? selectedCountries[countryItem]["dates"]["enddate"]
                    : ""
                }
                onChange={(newDate) => {
                  setDate(newDate, countryItem, "enddate");
                }}
                placeholderText="YYYY-MM-DD"
                className="default-input"
                selectsEnd
              />
            </td>
          </tr>
        );
      }
    );
  };

  const mossCheckbox = (disabled) => {
    return (
      
      <label className={disabled || tableVatData.filter((tableItem) => tableItem.country === 'moss').length > 0 ? "disabled-input" : ""}>

        <Field
          name="EUR"
          component="input"
          type="checkbox"
          value="moss"
          imgurl="moss"
          checked={selectedCountries['moss'] !== undefined || tableVatData.filter((tableItem) => tableItem.country === 'Moss').length > 0}
          //disabled={disabled || tableVatData.filter((tableItem) => tableItem.name === 'Oss')}
          onClick={(e) => checkboxOnClick(e)}
        />
        <div className="icon moss"></div>
        Oss
      </label>
    );
  };

  const submitReportingPeriod = (selection, vatID, rowID) => {
    setReportingPeriodOptionsModal(true)
    setReportingPeriodOptions([])
    setCurrentPeriod({vatID, periodType: selection.value})

    // SET SELECT VALUE
    setCurrentReportingPeriod({
      ...currentReportingPeriod,
      [vatID]: {
        ...selection
      }
    })

    fetch(API_URL + GET_ADMIN_RETURNS_FOR_PERIOD + vatID + `?period=${selection.value}`, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + GET_TOKEN(),
        "Content-Type": "application/json",
      })
    })
      .then((res) => res.json())
      // .then((res) => console.log(res))
      .then((res) => setReportingPeriodOptions(res))
      .catch((err) => {
        console.log(err)
      });
  }

  const submitPeriod = () => {
    const submitBody = JSON.stringify({
      period: currentPeriod.selectedPeriod.rowPeriod,
      period_type: currentPeriod.periodType
    })

    fetch(API_URL + GET_ADMIN_RETURNS_FOR_PERIOD + currentPeriod.vatID, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + GET_TOKEN(),
        "Content-Type": "application/json",
      }),
      body: submitBody
    })
      .then(() => {
        setReportingPeriodOptionsModal(false)
        setReportingPeriodOptions([])
        setCurrentPeriod({})
      })
      .catch((err) => console.log(err))
      .finally(() => setDisableSubmit(false))
  }

  const postVatId = (vatID, value, type, indexOfRow) => {
    const submitBody = JSON.stringify({
      [type]: value
    })

    fetch(API_URL + POST_VAT_NUMBER_ID + vatID, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: submitBody,
    })
    .then((response) => response.json())
    .then((response) => {


      if (response.error) { 
        console.error(response.error)
      } else {

        const responseObject = {
          img: response.country.img,
          country: response.country.name,
          vat_number: response.vat_number,
          tax_payer_number: response.tax_payer_number,
          reg_date: response.dates.startdate,
          dereg_date: response.dates.enddate,
          type: response.type,
          id: response.id,
          reporting_period: periodTranslate(response.reporting_period),
        }
  
        const tempArray = tableVatData
        tempArray[indexOfRow] = responseObject

        setTableVatData([...tempArray])
      }
    })
    .catch(error => console.log(error));
  }

  const USER_VAT_REGISTRATIONS_COLUMNS = [
    {
      Header: "",
      accessor: "img",
    },
    {
      Header: "Country/State",
      accessor: "country",
    },
    {
      Header: "VAT Number",
      accessor: "vat",
      Cell: (cell) => {
        const vatID = cell.row.original.id
        const vatNumber = cell.row.original.vat_number !== null ? cell.row.original.vat_number : ''
        const taxPayerNumber = cell.row.original.tax_payer_number !== null ? cell.row.original.tax_payer_number : ''

        // console.log(tableVatData)

        return (
          <div className="flex-align-center vat_id">

            <div className="payer_id-wrapper">
              <Input 
                defaultValue={vatNumber}
                disabled={GET_USER_LEVEL() < 4 && vatNumber !== ''}
                id={'vat_id_' + vatID}
              />

              {cell.row.original.country === "Germany" && (
                <Input 
                  labelText="Tax payer ID"
                  className="tax_payer_id"
                  defaultValue={taxPayerNumber}
                  // inputValueHandler={value => {
                  //   // // console.log()
                  //   // setVatNumberUpdate({
                  //   //   ...vatNumberUpdate,
                  //   //   [vatID]: value
                  //   // })
                  // }}
                  // inputBlurHandler={value => postVatId(vatID, value)}
                  id={'tax_id_' + vatID}
                />
              )}
            </div>

            {/* {console.log(document.getElementById(`vat_id_${vatID}`))} */}
            {/* {console.log(vatValue === document.getElementById(`vat_id_${vatID}`).value) } */}
            {/* {vatValue !== document.getElementById(`vat_id_${vatID}`)?.value && */}
            
            <div className="button-wrapper">

              <button 
                className="default_button"
                onClick={(e) => {
                  const inputValue = document.getElementById(`vat_id_${vatID}`).value
                  inputValue !== null && postVatId(vatID, inputValue, 'vat_number', cell.row.id)
                }}
                disabled={GET_USER_LEVEL() < 4 && vatNumber !== ''}
              >Save</button>
            
            {cell.row.original.country === "Germany" && <button 
                className="default_button"
                onClick={(e) => {
                  const inputValue = document.getElementById(`tax_id_${vatID}`).value
                  inputValue !== null && postVatId(vatID, inputValue, 'tax_payer_number', cell.row.id)
                }}
              >Save</button>
            }
            </div>
          </div>
        )
      }
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Reporting period",
      accessor: "reporting_period",
      Cell: (cell) => {
        const vatID = cell.data[cell.row.id].id
        const constructorPeriodSelect = () => {

          return <SelectInput
            inputName="admin_reporting_period"
            inputValueHandler={(value => submitReportingPeriod(value, vatID, cell.row.id))}
            value={currentReportingPeriod[vatID] !== null ? currentReportingPeriod[vatID] : undefined}
            selectValues={reportingPeriodoptions}
          />
        }

        return GET_USER_LEVEL() >= 3
          ? constructorPeriodSelect()
          : <>{cell.value}</>
      },
    },
    {
      Header: "Registration date",
      accessor: "reg_date",
    },
  ];

  const USER_VAT_REGISTRATIONS_OPTIONS_COLUMNS = [
    {
      Header: "Country",
      accessor: "country_cell",
      className: "cell_country",
      Cell: (cell) => {
        return <div className="countryCell">
          <img src={cell.data[cell.row.id].country.img} alt="flag" className="flag-icon-img"/>
          {cell.data[cell.row.id].country.name}
        </div>
      }
    },
    {
      Header: "Return Type",
      accessor: "return_type",
    },
    {
      Header: "Period",
      accessor: "period",
    },
    {
      Header: "",
      accessor: "radio",
      Cell: (cell) => {
        const rowID = cell.row.id
        const rowPeriod = cell.data[cell.row.id].period

        return <input 
          type="radio" 
          onChange={() => setCurrentPeriod({...currentPeriod, selectedPeriod: {rowPeriod, rowID}})}
          checked={rowID === currentPeriod.selectedPeriod?.rowID}
        />
      }
    }
  ]

  // GET countries
  useEffect(() => {
    if (OBJECT_EMPTY(countries)) {
      fetch(API_URL + GET_VAT_COUNTRIES)
        .then((response) => response.json())
        .then((data) => setCountries(data));
    }
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let newVatData = [];
    let newPeriodData = {}

    fullVatData && fullVatData.map((item) => {
      newPeriodData = {
        ...newPeriodData,
        [item.id]: {
          label: periodTranslate(item.reporting_period),
          value: item.reporting_period,
        }
      }

      return newVatData = [
        ...newVatData,
        {
          img: item.country.img,
          country: item.country.name,
          vat_number: item.vat_number,
          tax_payer_number: item.tax_payer_number,
          reg_date: item.dates.startdate,
          dereg_date: item.dates.enddate,
          type: item.type,
          id: item.id,
          reporting_period: periodTranslate(item.reporting_period),
        }
      ];
    });

    setCurrentReportingPeriod(newPeriodData)
    setTableVatData(newVatData)
  // eslint-disable-next-line
  }, [fullVatData]);

  // GET TABLE OF REGISTRATIONS
  useEffect(() => {
    setDataLoaded(false);
    setSelectedCountries({})

    fetch(
      API_URL + GET_ME,
      {
        method: "get",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => setFullVatData(response.vat))
      .then(() => setDataLoaded(true));
  }, [currentPage, addNewVatReg]);

  // SUBMIT NEW VAT REGISTRATION 
  const onSubmit = async (values) => {
    const countriesForPost = [];

    Object.entries(selectedCountries).map(
      ([currentCountry, currentCountryValue]) => {
        return countriesForPost.push(currentCountryValue);
      }
    );

    setIsLoading(true);

    await fetch(API_URL + POST_ME, {
        method: "POST",
        headers: new Headers({
          Authorization: "Bearer " + GET_TOKEN(),
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          countries: countriesForPost,
        }),
      })
        .then(() => {
          setIsLoading(false);
          setAddNewVatReg(false);
          setShowModal(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err)
        });
  };

  const VatTable = ({ columns, data }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

    return (
      <>
        <table {...getTableProps()} className="default-table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <React.Fragment key={column.id}>
                    {column.Header !== "" && (
                      <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      >
                      {column.render("Header")}

                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                    )}
                  </React.Fragment>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              let flagURL = '';

              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell, index) => {

                    if (cell.column.id === "vat" && cell.value === "") {
                      return (
                        <td {...cell.getCellProps()}>
                          <Link to="#" exact="true" className="blue_link">Add registration number</Link>
                        </td>
                      );
                    } 

                    else if (cell.column.id === "country") {
                      return (
                        <td {...cell.getCellProps()}>
                          <div className="flex-align-center">
                              {flagURL && (
                                <img
                                  src={flagURL}
                                  className="flag-icon-img"
                                  alt={cell.value}
                                />
                              )}
                              {cell.value == "Moss" ? "Oss" : cell.value}
                            </div>
                        </td>
                      )
                    }

                    else if (cell.column.id === "img") {
                      flagURL = cell.value
                      return; 
                    }

                    else {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    }

                  })}
                  <td>
                    <div className="table__settings--wrapper">
                      <button
                        type="button"
                        className="table__open-settings icon"
                        onClick={tableTooltip}
                      />

                      <ul className="table__settings">
                        <li>
                          {/*eslint-disable-next-line*/}
                          <a href="#">Request Remove</a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              );
            })}

          </tbody>
        </table>
        <br />
      </>
    );
  };

  return (
    <div className="VatRegistrations widget">

    {!addNewVatReg ? (
      <>
        <div className="Dashboard__content__top-row">
          <h2>My Registrations</h2>

          <ul className="Dashboard__content__top-row__selectors">
            <div onClick={() => setAddNewVatReg(true)} className="button__add-new"></div>
          </ul>
        </div>

        {tableVatData.length > 0 && dataLoaded === true ? (
          <>
            {/* {console.log(tableVatData)} */}
            <VatTable columns={USER_VAT_REGISTRATIONS_COLUMNS} data={tableVatData} />

            {maxPageCount > 1 && (
              <Pager
                currentPage={currentPage}
                maxPageCount={maxPageCount}
                currentPageSetter={currentPageSetter}
                currentPageSetterIncrease={currentPageSetterIncrease}
                currentPageSetterDecrease={currentPageSetterDecrease}
              />
            )}

          </>
        ) : dataLoaded 
            ? <EmptyData title="You don’t have any VAT registrations"/>
            : <LoadingSpinner/>
        }
      </>
    )

    : (
        <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting, values }) => (
          <form onSubmit={handleSubmit} noValidate>

            {currentStep === 1 &&
              (OBJECT_EMPTY(countries) ? (
                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
              ) : (
                <div className="RegisterCountrySelect registration-page-step">
                  <h3 className="registration-page-step__title">
                    Please select your current VAT registrations
                  </h3>
                  <div className="registration-page-step__country-select">
                    <div className="RegisterCountrySelect__continents-row">
                      {getContinents(values)}
                    </div>

                    <div className="RegisterCountrySelect__countries-table">
                      {getCountries()}
                    </div>
                  </div>
                  <div className="registration-page-step__button-wrapper">
                    <button
                      type="button"
                      disabled={Object.keys(selectedCountries).length === 0}
                      className="registration-input registration-input__button"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      proceed
                    </button>
                  </div>

                  {/* modal part */}
                  <div
                    className={
                      "modal " +
                      (!showModal ? "hide " : "") +
                      (modalLoading ? "loading " : "")
                    }
                  >
                    <div className="modal__content">
                      <div className="modal__top-row">
                        <button
                          type="button"
                          className="icon"
                          onClick={() => setShowModal(false)}
                        ></button>
                        <h1>Registration Dates</h1>
                      </div>

                      <div className="modal__table-wrapper">
                        <table className="modal__table">
                          <thead>
                            <tr>
                              <th>Region</th>
                              <th>Registration date *</th>
                              <th>De-registration date</th>
                            </tr>
                          </thead>

                          <tbody>{listSelectedCountriesModal()}</tbody>
                        </table>
                      </div>

                      <div className="modal_button">
                        <button
                          type="submit"
                          className="registration-input registration-input__button"
                        >
                          Save & Finnish
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </form>
        )} />
      )
    }

      {/* Reporting Period options table */}
      <Modal
        ModalOpenHandler={(value) => setReportingPeriodOptionsModal(value)}
        ModalOpen={reportingPeriodOptionsModal}
        customClassName={'modal__vatreg_table_modal'}
        title={'Choose return starting period'}
        closeButton
      >
        <div className="scrollable-wrapper">
          <ReactTable columns={USER_VAT_REGISTRATIONS_OPTIONS_COLUMNS} data={reportingPeriodOptions} />
        </div>

        <button className="default_button" disabled={disableSubmit} onClick={(e) => {
          setDisableSubmit(true)
          submitPeriod();
        }}>Save</button>
      </Modal>
    </div>
  );
};
